<template>
  <!-- Field Ownership 영역 배지 (ux-patterns.md §11.4, §4) -->
  <a-tooltip v-if="showTooltip" :title="tooltipText">
    <a-tag :color="tagColor" :style="{ fontSize: size === 'small' ? '10px' : '12px', cursor: 'help' }">
      {{ badgeLabel }}
    </a-tag>
  </a-tooltip>
  <a-tag v-else :color="tagColor" :style="{ fontSize: size === 'small' ? '10px' : '12px' }">
    {{ badgeLabel }}
  </a-tag>
</template>

<script>
// @MX:SPEC: SPEC-ECOUNT-ETL-OPS-CONSOLE-001 REQ-OC-PRODUCTS-002

export default {
  name: 'FieldOwnershipBadge',
  props: {
    type: {
      type: String,
      default: 'etl', // 'etl' | 'shared' | 'operator'
    },
    showTooltip: { type: Boolean, default: true },
    size: { type: String, default: 'small' }, // 'small' | 'default'
  },
  computed: {
    tagColor() {
      const map = {
        etl: 'default',
        shared: 'processing',
        operator: 'purple',
      };
      return map[this.type] || 'default';
    },
    badgeLabel() {
      const map = {
        etl: 'ETL',
        shared: this.$t('ecountEtl_fieldOwnership_shared'),
        operator: this.$t('ecountEtl_fieldOwnership_operator'),
      };
      return map[this.type] || 'ETL';
    },
    tooltipText() {
      const map = {
        etl: this.$t('ecountEtl_fieldOwnership_etl_desc'),
        shared: this.$t('ecountEtl_fieldOwnership_shared_desc'),
        operator: this.$t('ecountEtl_fieldOwnership_operator_desc'),
      };
      return map[this.type] || '';
    },
  },
};
</script>
